import { lazy } from 'react';

const EditAccountingExpenses = lazy(() => import('./edit'));
const CreateAccountingExpenses = lazy(() => import('./create'));

export { EditAccountingExpenses, CreateAccountingExpenses };
